export const JOBS_FETCH = 'jobs/fetchSearch';
export const JOBS_FETCH_PENDING = `${JOBS_FETCH}/pending`;
export const JOBS_FETCH_FULFILLED = `${JOBS_FETCH}/fulfilled`;
export const JOBS_FETCH_REJECTED = `${JOBS_FETCH}/rejected`;

export const JOB_SEARCH_ONE_LOAD_START = 'JOB_SEARCH_ONE_LOAD_START';
export const JOB_SEARCH_ONE_LOAD_SUCCESS = 'JOB_SEARCH_ONE_LOAD_SUCCESS';
export const JOB_SEARCH_ONE_LOAD_FAILURE = 'JOB_SEARCH_ONE_LOAD_FAILURE';

export const JOB_SEARCH_CHANGE_FILTER = 'JOB_SEARCH_CHANGE_FILTER';
export const JOB_SEARCH_APPLY_SAVED_FILTER = 'JOB_SEARCH_APPLY_SAVED_FILTER';
export const JOB_SEARCH_RESET_FILTER = 'JOB_SEARCH_RESET_FILTER';
export const INITIALIZE_GEOGRAPHY = 'INITIALIZE_GEOGRAPHY';
export const JOB_SEARCH_FILTER_FROM_URL = 'JOB_SEARCH_FILTER_FROM_URL';

export const TOGGLE_JOB_RECOMMENDATIONS = 'TOGGLE_JOB_RECOMMENDATIONS';
export const REMOVE_JOB_RECOMMENDATIONS = 'REMOVE_JOB_RECOMMENDATIONS';

export const SET_SHOW_FILTER = 'SET_SHOW_FILTER';
export const SET_SORT = 'SET_SORT';
export const APPLY_SAVED_FILTER_ID = 'APPLY_SAVED_FILTER_ID';
export const MARK_FILTER_AS_SEARCHED = 'MARK_FILTER_AS_SEARCHED';
